/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';

import { Link } from '@one-thd/sui-atomic-components';

const { node, func, string } = proptypes;

export const ProductButtonText = ({ children, onClick = () => {}, underline = 'hover' }) => {
  if (!onClick) {
    return (
      <>
        {children}
      </>
    );
  }
  return (
    <Link
      component="button"
      onClick={onClick}
      underline={underline}
    >
      {children}
    </Link>
  );
};

ProductButtonText.propTypes = {
  children: node.isRequired,
  onClick: func,
  underline: string
};